












import { Component, Vue } from 'vue-property-decorator';
import ModuleForm from './components/moduleForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { moduleListInstance } from '@/model/ModuleListClass';

type IUpdateModuleParams = IModule.IRequest.IUpdateModuleParams;

@Component({
  components: {
    ModuleForm,
  },
})
export default class UpdateModule extends Vue {
  private moduleListInstance = moduleListInstance;
  get module() {
    return this.moduleListInstance.editItem;
  }
  get moduleInfo(): IUpdateModuleParams {
    return {
      title: this.module?.title || '',
      quotationId: this.module?.quotationId || '',
      due: this.module?.due || '',
      manDay: this.module?.manDay || 0,
      comment: this.module?.comment || '',
    };
  }
  private changeModule(module: IUpdateModuleParams): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.module) {
        reject('Error');
        return;
      }
      this.moduleListInstance.requestChangeItem(this.module, module).then((res) => {
        reslove(res);
        this.goListPage();
      }).catch((err) => {
        reject(err);
      });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Module',
    });
  }
}
